import { get } from 'lodash';

import { MODAL_TYPES } from 'state/constants';
import Settings from 'utils/Settings';

const openGeofencingShopSelectorEvent = action => {
  const modalType = get(action, 'payload');

  if (modalType === MODAL_TYPES.GEOFENCING_SHOP_SELECTOR) {
    return {
      hitType: 'event',
      eventCategory: 'global',
      eventAction: 'viewModal',
      eventLabel: 'geofencing',
    };
  }

  return null;
};

const selectShopEvent = action => {
  const selectedShopID = get(action, 'payload');
  const currentShopID = Settings.shopID;
  const eventAction =
    selectedShopID === currentShopID ? 'selectSameCountry' : 'selectRecommendedCountry';

  return {
    hitType: 'event',
    eventCategory: 'global',
    eventAction,
    eventLabel: 'geofencing',
  };
};

export { selectShopEvent, openGeofencingShopSelectorEvent };
